/**
 * TurfAI Website Configuration
 * Centralized configuration for all website links and settings
 */

// Environment variables with fallbacks
const env = {
  SANDBOX_URL: import.meta.env.VITE_SANDBOX_URL || 'https://staging.turfai.in/',
  LOGIN_WITH_GMAIL_URL: import.meta.env.VITE_LOGIN_WITH_GMAIL_URL || 'https://staging.turfai.in/auth/google',
};

export const siteConfig = {
  // Company Information
  company: {
    name: 'TurfAI',
    legalName: 'Ariviti Technologies Private Limited',
    copyrightYear: new Date().getFullYear(),
    copyrightUrl: 'https://ariviti.com',
  },

  // URLs
  urls: {
    sandbox: env.SANDBOX_URL,
    loginWithGmail: env.LOGIN_WITH_GMAIL_URL,
    // Developer portal + user guide (Fumadocs). Default to localhost dev ports; override via .env.
    developers: import.meta.env.VITE_DEVELOPERS_URL || 'http://localhost:4174',
    userGuide: import.meta.env.VITE_USER_GUIDE_URL || 'http://localhost:4175',
  },

  // Social Media Links
  social: {
    linkedin: 'https://www.linkedin.com/company/turfai',
    twitter: 'https://x.com/ArivitiTech',
  },

  // Contact Information
  contact: {
    // ariviti.com addresses; each can be overridden at build time in apps/website/.env.
    general: import.meta.env.VITE_CONTACT_EMAIL || 'hello@ariviti.com', // business enquiries
    support: import.meta.env.VITE_SUPPORT_EMAIL || 'customer@ariviti.com', // existing customers
    sales: import.meta.env.VITE_SALES_EMAIL || 'hello@ariviti.com',
    jobs: import.meta.env.VITE_CAREERS_EMAIL || 'careers@ariviti.com',
    phone: '+91 80 4663 2400',
    phoneHref: 'tel:+918046632400',
  },

  // Navigation Links
  navigation: {
    products: [
      { id: 'stageone', title: 'StageOne', description: 'AI hiring assessments', color: 'purple' },
      { id: 'learning', title: 'Learning tools', description: 'SkillUp, DataLab and FishBone', color: 'teal' },
      { id: 'promptbench', title: 'PromptBench', description: 'AI model and prompt evaluation', color: 'orange' },
    ],
  },

  // Footer Links
  footer: {
    legal: [
      { label: 'Privacy Policy', href: '/privacy-policy' },
      { label: 'Terms of Service', href: '/terms-of-service' },
      { label: 'Security', href: '/security' },
    ],
  },
};

export type SiteConfig = typeof siteConfig;
